// This icon file is generated automatically.
var DrrpDacfeecountIconOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 40 40", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M32.02 5.8H8.06a4.23 4.23 0 00-4.23 4.23v21.14c0 2.34 1.9 4.23 4.23 4.23h23.96c2.34 0 4.23-1.9 4.23-4.23V10.03c0-2.34-1.9-4.23-4.23-4.23zm1.41 19.03h-9.16a4.24 4.24 0 010-8.46h9.16v8.46zm-9.16-10.58a6.34 6.34 0 100 12.7h9.16v4.22c0 .78-.63 1.41-1.4 1.41H8.05c-.78 0-1.41-.63-1.41-1.4V10.02c0-.78.63-1.41 1.4-1.41h23.97c.78 0 1.41.63 1.41 1.4v4.24h-9.16zm-1.41 6.35a1.41 1.41 0 102.82 0 1.41 1.41 0 00-2.82 0z", "fill-rule": "nonzero" } }] }, "name": "drrp-dacfeecount-icon", "theme": "outlined" };
export default DrrpDacfeecountIconOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/DrrpDacfeecountIconOutlined.js
// module id = 2502
// module chunks = 0